import { Injectable } from '@angular/core';
import { IIDepAssetsStore } from './iidEPAssets.store';
import { IID_EP_ASSET } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDepAssetsQuery } from './iidEPAssets.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.ASSETS)
export class IIDepAssetsService extends CrudService<IID_EP_ASSET, IIDepAssetsStore, IIDepAssetsQuery> {
  constructor(
    protected store: IIDepAssetsStore,
    public query: IIDepAssetsQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.IID_EP_ASSETS,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
